import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './styles/source.scss';

import Inicio from './paginas/Inicio'
import EstadoArte from './paginas/EstadoArte'
import Metodo from './paginas/Metodo'
import Manual from './paginas/Manual'
import Biblioteca from './paginas/Biblioteca'
import Nav from './components/Nav'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: ''
    }

    this.onClickChangeState = this.onClickChangeState.bind(this);
  }

  onClickChangeState(state_temp) {

  }

  render() {
    return (
      <Router>
        <div id="container">
          <div id="background"></div>
          <Nav selected={this.state.selected} />
          <Switch>
            <Route path="/PFMMC/fr/" exact component={Inicio} />
            <Route path="/PFMMC/fr/etat" exact component={EstadoArte} />
            <Route path="/PFMMC/fr/mmk" exact component={Metodo} />
            <Route path="/PFMMC/fr/manuel" exact component={Manual} />
            <Route path="/PFMMC/fr/multimedia" exact component={Biblioteca} />
          </Switch>
        </div>
      </Router>
    )
  }
}

export default App;
